import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { createStore, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { Provider } from 'react-redux';
import { reduxFirestore, getFirestore } from 'redux-firestore';
import { reactReduxFirebase, getFirebase } from 'react-redux-firebase';
import firebaseConfig from './config/firebaseConfig';
import rootReducer from './store/root/rootReducer';
import ReactGA from "react-ga";
import UUIDV4 from "uuid/v4";


// Remove old UUID
if (localStorage.getItem("nemu-uuid") !== null ||
    localStorage.getItem("nemu-uuid") !== undefined) {
    localStorage.removeItem("nemu-uuid")
}

// ///////////////////////
// SET STORAGE AS SESSIONS AND UUID

if (!localStorage.getItem("nemu-uid")) {
    localStorage.setItem("nemu-uid", UUIDV4())
}

// ///////////////////////



ReactGA.initialize('UA-138910675-1', {
    debug: false
});
ReactGA.pageview(window.location.pathname + window.location.search);

const store = createStore(
    rootReducer,
    compose(
        applyMiddleware(
            thunk.withExtraArgument({
                getFirebase,
                getFirestore
            })
        ),
        reduxFirestore(firebaseConfig),
        reactReduxFirebase(
            firebaseConfig,
            {
                useFirestoreForProfile: true,
                userProfile: "users",
                attachAuthIsReady: true
            }
        )
    )
);

store.firebaseAuthIsReady
    .then(() => {
        ReactDOM.render(<Provider store={store}><App /></Provider>, document.getElementById('root'));
        serviceWorker.unregister();
    });
